import React, { useState, useEffect } from "react";

import MovieCard from "./MovieCard";         //API Key=bf43015e
import SearchIcon from "./search.svg";
import "./App.css";

const API_URL = "https://www.omdbapi.com?apikey=b6003d8a";

const App = () => {
  const [searchTerm, setSearchTerm] = useState(""); // UseState for our search to function
  const [movies, setMovies] = useState([]); // A useState to map over our movies library

  // Here, we use UseEffect to call our API
  useEffect(() => {
    searchMovies("Batman");
  }, []);

  const searchMovies = async (title) => {
    const response = await fetch(`${API_URL}&s=${title}`);
    const data = await response.json();

    setMovies(data.Search); // Now we pass our data.search into our setMovies function.It give access to our movies 
  };

  return (
    <div className="app">
      <h1>MovieLand</h1>

      <div className="search">
        <input
          value={searchTerm} // Here, we can search for any movie, by entering it inside the placeholder on the browser. The searchTerm function makes it dynamic
          onChange={(e) => setSearchTerm(e.target.value)} //We use the SetsearchTerm function to update our State value(using Event(e) change) each time there's a click on the SearchIcon, onChange prop to make the input value dynamic. 
          placeholder="Search for movies"
        />
        <img
          src={SearchIcon} // Displays the search icon 
          alt="search" // Alt text for image--screen readers
          onClick={() => searchMovies(searchTerm)} // To make the search icon search through the movies arrays to render the SearchMovies function value as applicable, when we click the search icon.
        />
      </div>

      {movies?.length > 0 ? (  // If movies length is greater than 0 render div class=container
        <div className="container">       
          {movies.map((movie) => (  // We map over our movie, to search tru the arrays of movies one by one
            <MovieCard movie={movie} /> //This is what we render when we map.We pass the movie props into the MovieCard Components
          ))}
        </div>
      ) : (                       // else render div classname is empty
        <div className="empty">
          <h2>No movies found</h2>
        </div>
      )}
    </div>
  );
};

export default App;
